// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SaveThirdPartyIdRequestModel {
    static getAttributeTypeMap() {
        return SaveThirdPartyIdRequestModel.attributeTypeMap;
    }
}
SaveThirdPartyIdRequestModel.discriminator = undefined;
SaveThirdPartyIdRequestModel.attributeTypeMap = [
    {
        "name": "thirdPartyId",
        "baseName": "thirdPartyId",
        "type": "string"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    }
];
//# sourceMappingURL=saveThirdPartyIdRequestModel.js.map